import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import DocumentTasksListItemComponent from './DocumentTasksListItemComponent';
import { Typography } from '@totalsoft/rocket-ui';
import ThinDivider from 'components/common/ThinDivider';
import { withRights } from 'providers/RightsConsumer';

export const DocumentTasksListComponent = ({ t, documentTasks, onOpenModal, onAssignToMe, onPauseTask, onStartTask, isFolder, userInfo }) =>
  !documentTasks || documentTasks.length === 0 ? (
    <Grid container alignItems='center' px={3} py={2}>
      <Grid item xs={12}>
        <Typography>{isFolder ? t('Folder.NoFolderTasks') : t('Offer.NoOfferTasks')}</Typography>
      </Grid>
    </Grid>
  ) : (
    <Grid container spacing={1} alignItems='center' px={3} py={2}>
      <Grid item xs={12}>
        <Typography variant='subtitle1' color='primary' fontWeight='bold' textTransform='uppercase'>
          {isFolder ? t('Folder.FolderTasksTitle') : t('Offer.OfferTasksTitle')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <ThinDivider />
      </Grid>
      {documentTasks.map((task, index) => {
        return (
          <DocumentTasksListItemComponent
            task={task}
            key={index}
            onOpenModal={onOpenModal}
            onAssignToMe={onAssignToMe}
            onPauseTask={onPauseTask}
            onStartTask={onStartTask}
            userInfo={userInfo}
          />
        );
      })}
    </Grid>
  );

DocumentTasksListComponent.propTypes = {
  documentTasks: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onAssignToMe: PropTypes.func.isRequired,
  onPauseTask: PropTypes.func.isRequired,
  onStartTask: PropTypes.func.isRequired,
  isFolder: PropTypes.bool.isRequired,
  userInfo: PropTypes.object.isRequired
};

export default compose(withTranslation())(withRights(DocumentTasksListComponent));
